import { Box } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import { ArrowLeft } from 'react-feather'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'

export const Breadcrumb = ({ content }) => {
  let breadcrumbText = ''

  if (content instanceof String) {
    breadcrumbText = content
  }
  if (content instanceof Object) {
    breadcrumbText = content?.textContent?.json?.content?.[0]?.content[0]?.value
  }

  return (
    <Box paddingTop={3} display={'flex'} alignItems={'center'} gap={1} className={''}>
      <AchieveLink
        href="/about/press"
        className={''}
        track={{
          list_name: 'Breadcrumb',
          click_text: breadcrumbText,
          click_id: breadcrumbText,
          click_position: '0',
          nav_link_section: 'Breadcrumb',
          track_event: 'page_nav_click',
          event_action: 'link_click',
          event_type: 'link_click',
        }}
      >
        <Box className={'flex items-center'}>
          <ArrowLeft className={'text-blue-500 cursor-pointer font-bold w-[14px] h-[14px]'} />
          <Typography
            content={breadcrumbText}
            className={'text-blue-500 leading-[0] ml-[10px]'}
            variant="bodySm"
            fontWeight="bold"
          />
        </Box>
      </AchieveLink>
    </Box>
  )
}
